import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=7ab6a78b&scoped=true"
import script from "./GlobalHeader.vue?vue&type=script&lang=js"
export * from "./GlobalHeader.vue?vue&type=script&lang=js"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=7ab6a78b&prod&lang=less"
import style1 from "./GlobalHeader.vue?vue&type=style&index=1&id=7ab6a78b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab6a78b",
  null
  
)

export default component.exports